<template>
	<div class="fixed-operate-wrapper">
		<div :class="containerClass">
			<slot />
		</div>
	</div>
</template>

<script setup>
import { computed, provide } from 'vue';

const props = defineProps({
	mode: {
		type: String,
		default: 'pc',
		validator: value => ['pc', 'mobile'].includes(value)
	}
});
provide('mode', props.mode);

// 容器样式
const containerClass = computed(() => {
	return props.mode === 'pc' ? 'fixed-action' : 'fixed-mobile-action';
});

// 按钮样式
const normalButtonClass = computed(() => {
	const baseClass = props.mode === 'pc' ? 'action-block' : 'mobile-action-block';
	return baseClass;
});
const roundButtonClass = computed(() => {
	const baseClass = props.mode === 'pc' ? 'action-block' : 'mobile-action-block mobile-action-round';
	return baseClass;
});
provide('normalButtonClass', normalButtonClass);
provide('roundButtonClass', roundButtonClass);
</script>

<style lang="less">
.fixed-operate-wrapper {
	// PC 版本样式
	.fixed-action {
		position: fixed;
		right: 40px;
		bottom: 64px;
		z-index: 101;
		padding: 20px 4px;
		display: flex;
		flex-direction: column;
		border-radius: 80px;
		background: #fff;
		text-align: center;
		filter: drop-shadow(1px 4px 16px rgba(0, 0, 0, 0.08));
		backdrop-filter: blur(7px);

		// PC端按钮通用样式
		.action-block {
			cursor: pointer;
			margin-top: 20px;

			&:first-child {
				margin-top: 0;
			}

			&:not(:first-child) {
				position: relative;

				&::before {
					content: '';
					position: absolute;
					top: -10px;
					left: 12px;
					right: 12px;
					height: 1px;
					background: #f2f3f5;
					transform: scaleY(0.5);
					pointer-events: none;
				}
			}

			&:hover {
				.action-block-span {
					color: var(--theme-color);
				}
				.c-action-svg {
					color: var(--theme-color) !important;
				}
			}

			&.action-block--disabled {
				cursor: not-allowed;

				.action-block-span {
					color: #c9cdd4;
				}
				.c-action-svg {
					color: #c9cdd4 !important;
				}
				&:hover {
					.action-block-span {
						color: #c9cdd4;
					}
					.c-action-svg {
						color: #c9cdd4 !important;
					}
				}
			}

			.action-block-span {
				display: block;
				margin-top: 8px;
				color: #1d2129;
				font-size: 12px;
				font-weight: 400;
				line-height: 16px;
			}

			.c-action-svg {
				font-size: 24px;
				color: #4e5969 !important;
			}
		}
	}

	// 移动端版本样式
	.fixed-mobile-action {
		position: fixed;
		z-index: 41;
		right: 14px;
		bottom: 112px;
		display: flex;
		flex-direction: column;

		// 移动端按钮通用样式
		.mobile-action-block {
			margin-top: 12px;
			font-size: 0;

			&:first-child {
				margin-top: 0;
			}

			img {
				width: 48px;
				height: 51px;
			}

			&.mobile-action-round {
				width: 48px;
				height: 48px;
				background: #ffffff;
				box-shadow: 0 3px 3px rgba(0, 0, 0, 0.02);
				border-radius: 50%;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				.mobile-action-svg {
					font-size: 24px;
				}
			}
		}
	}
}
</style>
